<template>
  <div class="pl-20 pr-20">
    <div class="flex a-center">
      <div>下单时间：</div>
      <div>
        <a-radio-group v-model="timeSestion" button-style="solid">
          <a-radio-button :value="1">
            昨天
          </a-radio-button>
          <a-radio-button :value="2">
            今天
          </a-radio-button>
          <a-radio-button :value="3">
            近7天
          </a-radio-button>
          <a-radio-button :value="4">
            自定义
          </a-radio-button>
        </a-radio-group>
      </div>
      <div><a-range-picker v-if="timeSestion === 4" v-model="time" class="w-302" /></div>
      <div class="ml-20"><a-button type="primary" @click="search">查 询</a-button> <a-button @click="reset">清 空</a-button> <a-button :loading="loading" @click="exp">导出Excel</a-button></div>
    </div>
    <div class="mt-20 flex a-center flex-wrap">
      <div class="flex a-center mr-20 mb-20">
        <div>下单账号：</div>
        <div>
          <a-select v-model="params.customerId" class="w-160" placeholder="请选择员工">
            <a-select-option :key="-1" :value="''">
              全部
            </a-select-option>
            <a-select-option v-for="(i,index) in staffList" :key="index" :value="i.staffid">
              {{ i.staffname }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <!-- <div class="flex a-center mr-20 mb-20">
        <div class="">快递公司：</div>
        <div>
          <a-select v-model="params.shipperCode" class="w-174">
            <a-select-option v-for="(i,index) in companys" :key="index" :value="i.shipperCode">{{ i.shipperName }}</a-select-option>
          </a-select>
        </div>
      </div> -->
      <!-- <div class="flex a-center mr-20 mb-20">
        <div class="">订单状态：</div>
        <div>
          <a-select v-model="params.shipperCode" class="w-174">
            <a-select-option :key="-1" :value="''">请选择订单状态</a-select-option>
          </a-select>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      timeSestion: 2,
      time: null,
      companys: [],
      staffList: [],
      loading: false,
      params: {
        customerId: '',
        'startTime': this.$moment().format('YYYY-MM-DD'),
        'endTime': this.$moment().format('YYYY-MM-DD')
      }
    }
  },
  watch: {
    timeSestion(n) {
      if (n === 1) {
        this.params.startTime = moment().subtract(1, 'days').format('YYYY-MM-DD')
        this.params.endTime = this.params.startTime
      } else if (n === 2) {
        this.params.startTime = moment().format('YYYY-MM-DD')
        this.params.endTime = this.params.startTime
      } else if (n === 3) {
        this.params.startTime = moment().subtract(7, 'days').format('YYYY-MM-DD')
        this.params.endTime = moment().format('YYYY-MM-DD')
      } else if (n === 4) {
        this.params.startTime = ''
        this.params.endTime = ''
      }
    },
    time(n) {
      if (!n || !n.length) {
        this.params.startTime = ''
        this.params.endTime = ''
      } else {
        this.params.startTime = n[0].format('YYYY-MM-DD')
        this.params.endTime = n[1].format('YYYY-MM-DD')
      }
    }
  },
  async created() {
    const staffList = await this.$http(this.$api.staffGetStaffList, {})
    this.staffList = staffList || []
  },
  methods: {

    exp() {
      this.$emit('exp', this)
    },
    search() {
      this.$emit('search', this.params)
    },
    reset() {
      this.time = null
      this.timeSestion = 2
      Object.assign(this.params, {
        'endTime': '',
        'startTime': '',
        customerId: ''

      })
      this.$nextTick(() => {
        this.$emit('reset', this.params)
      })
    }
  }
}
</script>
